import { Listing } from "@t/Listing"

function isBetween(num: number, lower: number, upper: number): boolean {
    return num >= lower && num <= upper
}

export function getPointStatus(listing: Pick<Listing, "points_on_contract" | "initial_point_variation">) {
    const points = listing.points_on_contract
    const minusPoints = -listing.points_on_contract
    const ipv = listing.initial_point_variation
    if (ipv === 0) {
        return "Normal"
    }
    if (ipv <= minusPoints) {
        return "Stripped"
    }
    if (isBetween(ipv, minusPoints + 1, -1)) {
        return "Partially stripped"
    }
    if (isBetween(ipv, 1, points - 1)) {
        return "Some extra"
    }
    if (ipv >= points) {
        return "Loaded"
    }
    return ""
}

export function getPointsText(min: number, max: number) {
    if (max === 9999) {
        return `${min} or more points`
    }
    return `${min} - ${max} points`
}
